



































import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import toIconClass from '@/filters/to-icon-class'

interface FilterItem {
  /**
   * filter item의 고유한 id, emit event 발생시 사용
   */
  id: string
  /**
   * filter item 버튼 내부 오른쪽 아이콘 표시
   */
  icon: string
  /**
   * filter item 버튼명 표시
   */
  value: string
}

/**
 * @displayName PageFilters
 * totalCount, refresh button, filter item list를 포함한 component
 */
@Component({
  filters: {
    toIconClass
  }
})
export default class PageFilters extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  /**
   * totalCount will place into a left side 총 totalCount건
   */
  @Prop() totalCount: number
  /**
   * visible refresh icon
   * refresh icon place into a keep-refresh-sm icon right of totalCount
   */
  @Prop({default: true, type: Boolean}) visibleRefresh: boolean
  /**
   * disabled state
   * opacity style, button disabled set
   */
  @Prop({default: false, type: Boolean}) disabled: boolean
  /**
   * filter item list
   * filterItemList place into a right side buttons
   */
  @Prop() filterItemList: FilterItem[]
  /**
   * Return totalCount styles
   */
  get countStyle(): object {
    return {
      opacity: this.disabled ? '0.7' : '1'
    }
  }
  /**
   * Return filterItemList styles
   */
  get filtersStyle(): object {
    return {
      opacity: this.disabled ? '0.7' : '1'
    }
  }
  /**
   * Emit filter item id
   */
  onClickFilterItem(id) {
    this.$emit('filter-item', id)
  }
}
